// -----------------------------------------------------------------------------
// Hub layout: side navbar, bottom navbar (mobile), top bar
// -----------------------------------------------------------------------------
export const NOT_A_NUMBER_LABEL = 'N/A'

export const defaultColorScheme = 'dark'
